// src/context/personaAssistApi.js — /api/v1/persona-assist/* (BE c84cb07). Admin of the workspace only.
// ⛔ Every call names its workspace (?tenant= + suppressTenantHeader). ⚠️ The two POSTs SPEND credits (a failed
// proposal or job is not charged); the two GETs are free. Errors via parseApiError → branch on err.code.
import { apiFetch } from '../auth/apiFetch.js';
import { parseApiError } from './parseApiError.js';

const BASE = '/api/v1/persona-assist';
function url(path, tenant) {
  if (!tenant) throw new TypeError('personaAssistApi: a tenant id is required');
  return `${BASE}${path}?${new URLSearchParams({ tenant }).toString()}`;
}
async function send(target, init) {
  const res = await apiFetch(target, { ...init, suppressTenantHeader: true });
  if (!res.ok) throw await parseApiError(res);
  return res.json();
}
// Not `async` on purpose: a missing tenant must throw SYNCHRONOUSLY, before any request is issued.
function call(path, tenant, init = {}) {
  return send(url(path, tenant), init);
}

/** POST /propose — 200 {proposals, kb_used, documents, warnings}. Synchronous (a few seconds). */
export function proposePersonas({ tenant, request, documents = [] }) {
  const body = { request };
  if (documents.length) body.documents = documents;
  return call('/propose', tenant, { method: 'POST', body: JSON.stringify(body) });
}

/** POST /jobs — 202 {job_id, kind, status:'pending'}. `body` from assistModel.buildCreateBody / buildPersonalizeBody. */
export function startPersonaJob({ tenant, body }) {
  return call('/jobs', tenant, { method: 'POST', body: JSON.stringify(body) });
}

/** GET /jobs/{id} — free. 404 PERSONA_JOB_NOT_FOUND for an unknown / foreign / malformed id. */
export function getPersonaJob({ tenant, jobId }) {
  return call(`/jobs/${encodeURIComponent(jobId)}`, tenant);
}

/** GET /jobs — free. The ACTIVE job, else the NEWEST; null when none. */
export function getLatestPersonaJob({ tenant }) {
  return call('/jobs', tenant).then((data) => (data && data.job ? data.job : null));
}
